<template>
  <UPopover v-model:open="showDropdown"
      :content="{
      align: 'start',
    }"
  >
    <UButton variant="ghost" color="neutral" size="lg" >
      <span class="animate-target">{{ selectedCurrency?.label }}</span>
      <Icon name="i-heroicons-chevron-down" class="w-4 h-4" />
    </UButton>

    <template #content>
      <div class="p-2 space-y-1 min-w-[150px]">
        <NuxtLink
          v-for="state in currencies"
          :key="state.value"
          @click="selectState(state)"
          class="block px-3 py-2 text-sm hover:bg-gray-100 rounded transition-colors"
        >
          {{ state.label }}
        </NuxtLink>
      </div>
    </template>
  </UPopover>
</template>

<script setup lang="ts">
import { useCurrencyStore } from '~/stores/useCurrencyStore'
const showDropdown = ref(false)

const currencyStore = useCurrencyStore()

const currencies = [
  { value: 'EUR', label: 'Euro' },
  { value: 'USD', label: 'US Dollar'}
]

const selectedCurrency = computed(() => {
  return currencies.find(c => c.value === currencyStore.currency)
})

function selectState(state: typeof currencies[0]) {
  currencyStore.currency = state.value.toUpperCase() as 'EUR' | 'USD'
  showDropdown.value = false
}
</script>

